<template>
    <div class="page-edit">
        <v-page-header
            :title="isCreate ? '新建权限角色' : '编辑权限角色'"
            :back="{
                title: '权限角色',
                url: '/mng/role',
            }"
        />
        <div
            v-spinner="pageLoading"
            class="page-edit-box"
        >
            <v-spinner
                :opacity="0.5"
                size="large"
            />
            <role-name-input
                ref="roleNameInput"
                v-if="hasRoleInfoInit"
                v-show="!pageLoading"
                :key="editRoleNameKey"
                :val="roleName"
                @input="roleNameChange"
                clazz="role-copy-input"
            />
            <div
                v-if="!isCreate"
                class="package-show"
            >
                <div
                    v-if="curCombos && curCombos.length"
                    class="package-show__title"
                >
                    所属套餐
                </div>
                <div class="package-show__list">
                    <span
                        v-for="(item, index) in curCombos"
                        :key="index"
                        class="package-show__item"
                    >
                        <span
                            class="package-show__content"
                        >{{ item.name }}</span>
                        <span class="package-show__desc">{{ '(剩余' + item.remaining + ')' }}</span>
                    </span>
                </div>
                <div
                    v-if="otherCombos && otherCombos.length"
                    class="package-show__footer"
                >
                    <v-icon
                        name="basic_tips_line"
                        remote
                    />
                    <span class="package-show__footerItem">当前企业还购买了</span>
                    <span class="package-show__footerList">
                        <span
                            v-for="(item, index) in otherCombos"
                            :key="index"
                            class="package-show__footerItem"
                        >
                            <span>{{ item.name }}</span>
                            <span>{{ index < otherCombos.length - 1 ? '、' : '，' }}</span>
                        </span>
                    </span>
                    <span class="package-show__footerItem">如需选择这些套餐的功能权限，请重新选择对应套餐的模板并创建角色，<a
                        href="/mng/role/jumpcreate"
                        target="_blank"
                    >点击此处</a>前去创建</span>
                </div>
            </div>
            <priv-edit-list
                v-show="!pageLoading"
                :req-param="getPrivParam"
                :err-bo-id="errBoId"
                @init="privInit"
                @change="privChange"
            />
            <div
                v-show="!pageLoading"
                class="priv-edit-save-box"
            >
                <v-button
                    :loading="saveLoading"
                    @click="onCallSubimtDialog"
                    class="priv-edit-save-btn"
                    status="primary"
                    size="large"
                    kind="primary"
                >
                    保存
                </v-button>
                <v-button
                    @click="cancelClick"
                    status="default"
                    size="large"
                >
                    取消
                </v-button>
            </div>
            <v-dialog
                v-model="showChoosePackageDialog"
                :confirm-disabled="!choosePackageVal"
                @confirm="choosePackageConfirm"
                kind="confirm"
                class="choose-package-dialog"
            >
                <div
                    slot="title"
                    class="choose-package-tit"
                >
                    <v-icon name="v-error" />以下套餐均满足该角色的权限配置<br>请选择
                </div>
                <v-radio-group
                    v-model="choosePackageVal"
                    vertical
                >
                    <v-radio
                        v-for="item in packageRadioArr"
                        :key="item.id"
                        :value="item.id"
                        name="radio"
                    >
                        {{ item.name }}
                    </v-radio>
                </v-radio-group>
            </v-dialog>
            <v-dialog
                v-model="showHasQQSubmitDialog"
                @confirm="save"
                class="base-dialog"
                title="该角色含有QQ沟通相关的权限，保存后，将给该角色下所有员工分配QQ员工号"
                kind="confirm"
            >
                <span slot="confirm-text">保存</span>
                <div>如果员工已有QQ员工号，不会被重复分配</div>
            </v-dialog>
            <v-dialog
                v-model="showNoneQQSubmitDialog"
                @confirm="save"
                class="base-dialog"
                title="保存后，角色将不再含有QQ沟通相关的权限，可能会导致与QQ相关的业务不能正常运行"
                kind="confirm"
                status="warning"
            >
                <span slot="confirm-text">保存</span>
            </v-dialog>
            <v-dialog
                v-model="showUnderQuotaDialog"
                class="base-dialog-underQuota"
                title="QQ员工号配额不足，无法保存角色"
            >
                <div>请等待删除中的QQ员工号释放，或将不需要沟通能力的QQ员工号收回</div>
            </v-dialog>
        </div>
    </div>
</template>

<script>
import { ajax } from '@tencent/qd-lib';
import { isXtPackage } from '@/utils/package';
import { envDomain } from '@/utils/domainConfig';
import { isInAccountComplete } from 'src/cgi/getWhiteList';
import Gateway from 'src/utils/Gateway';
import terminalPriCheck from 'src/cgi/terminalPriCheck';
import roleNameInput from '../components/role-name-input';
import privEditList from '../components/priv-edit-list';

export default {
    components: {
        roleNameInput,
        privEditList,
    },

    beforeRouteLeave(to, from, next) {
        if (this.refreshList) {
            // 设置下一个路由的 meta
            to.meta.refresh = true; // 让列表页刷新列表
        } else {
            to.meta.refresh = false;
        }

        this.isChange = false;

        next();
    },
    data() {
        return {
            isCreate: false,
            editRoleNameKey: 'ernk',
            type: -1, // 1.从角色模板创建 2.从已有角色复制 3.编辑角色 4.另存为新角色
            roleId: -1, // 角色ID（type=2或者type=3会用到，type=1的情况下这里填模板id）
            roleName: '',
            privileges: [],
            terminalPrivileges: [],
            packages: [],
            confirmPackages: [],
            checkedPrivItem: [],
            choosePackageVal: '',
            showChoosePackageDialog: false,
            getPrivParam: {},
            saveLoading: false,
            hasPrivInit: false,
            hasQQPrivilege: false,
            hasRoleInfoInit: false,
            showHasQQSubmitDialog: false,
            showNoneQQSubmitDialog: false,
            showUnderQuotaDialog: false,
            pageLoading: true,
            confirmCgiUrl: '',
            confirmCgiType: 'post',
            packageInfo: {
                10002: '企点-商通基础版',
                10003: '企点客服-在线客服标准版',
                10004: '企点分析',
                10005: '企点客服-电话客服标准版',
                10007: '企点客服-在线客服企业版',
                10008: '企点客服-电话客服专业版',
                10009: '企点客服-在线客服专业版',
                10010: '企点营销企业版',
                10011: '企点商圈标准版',
                10012: '企点领航企业应用',
                10013: '企点商通-行业版',
                10015: '企点电话客服',
                10016: '企点-企业QQ 2.0 (协同)',
                10017: '企点客服-在线客服基础版',
                10018: '企点营销标准版',
                10019: '企点营销-智推专业版',
                10020: '八戒企业QQ免费版',
                10021: '八戒企业QQ增值版',
                10022: '企点商铺-标准版',
                10023: '腾讯企点-在线客服（平台基础版）',
                10024: '腾讯企点-在线客服（平台标准版）',
                10025: '企点营销-会销标准版',
                10026: '腾讯企点-云呼叫中心 (专业版)',
                10027: '腾讯企点-云呼叫中心 (企业版)',
                10028: '企点营销-社交零售解决方案',
                10035: '企点营销-智推标准版',
                10036: '展会定制客服基础版',
                10037: '企点商通-物流版',
                10039: '企点客服标准版（云官网）',
                10040: '企点客服专业版（云官网）',
            },
            errBoId: -1,
            accountCompleteTag: false,
            curCombos: [],
            otherCombos: [],
        };
    },
    computed: {
        packageRadioArr() {
            const choosePackArr = this.confirmPackages[0];
            const radioArr = [];

            if (choosePackArr && choosePackArr.length > 1) {
                choosePackArr.forEach((packKey) => {
                    radioArr.push({
                        id: packKey,
                        name: this.packageInfo[packKey],
                    });
                });
            }

            return radioArr;
        },
    },

    created() {
        if (this.$route.params.tplId) {
            this.isCreate = true;
            this.type = 1;
            this.roleId = this.$route.params.tplId;
            this.roleName = window.decodeURIComponent(this.$route.params.name);
            this.getPrivParam.templateId = this.roleId;
            this.hasRoleInfoInit = true;
            this.getTplData(this.$route.params.tplId);
            this.confirmCgiUrl = '/mng/role/roleCreate';
        } else {
            this.type = 3;
            this.roleId = this.$route.params.roleId;
            this.getPrivParam.roleId = this.roleId;
            this.getRoleInfo();
            this.confirmCgiUrl = `${envDomain.gateway}/v1/funcPrivilege/updateRole`;
            this.confirmCgiType = 'crossPost';
            // this.unloadTip();
            this.getCombos();
        }
    },

    mounted() {
        this.beforeUnloadTip();

        // 判断是否有完整的新账号功能
        isInAccountComplete().then((val) => {
            this.accountCompleteTag = val;
        });
    },

    methods: {
        roleNameChange(val) {
            this.roleName = val;
            this.isChange = true;
        },

        privInit(data) {
            this.hasPrivInit = true;
            this.setPageLoading();
            this.privChange(data, true);
            this.getPackagesInfo();
        },

        privChange(data, isInit) {
            const {
                checkedPrivIdArr,
                checkedPrivItem,
                checkedTerminalPrivIdArr,
                noIntersectionPackages, dataPriv,
            } = data || {};
            const packages = [];
            const confirmPackages = [];

            noIntersectionPackages.forEach((packArr) => {
                if (packArr.length === 1) {
                    packages.push(packArr[0]);
                } else if (packArr.length > 1) {
                    confirmPackages.push(packArr);
                }
            });

            this.privileges = checkedPrivIdArr;
            this.terminalPrivileges = checkedTerminalPrivIdArr;
            this.packages = packages;
            this.confirmPackages = confirmPackages;
            this.checkedPrivItem = checkedPrivItem;
            this.dataPriv = dataPriv;
            if (!isInit) {
                this.isChange = true;
            }
        },

        checkQQPrivilege() {
            const len = this.checkedPrivItem && this.checkedPrivItem.length;
            let hasQQPrivilege = false;
            if (len) {
                for (let i = 0; i < len; i += 1) {
                    if (this.checkedPrivItem[i] && this.checkedPrivItem[i].hasQQPrivilege) {
                        hasQQPrivilege = true;
                    }
                }
            }
            return hasQQPrivilege;
        },
        onCallSubimtDialog(e) {
            e.preventDefault();
            if (!this.accountCompleteTag || this.hasQQPrivilege === this.checkQQPrivilege()) {
                this.save();
            } else if (this.hasQQPrivilege && !this.checkQQPrivilege()) {
                this.showNoneQQSubmitDialog = true;
            } else {
                this.showHasQQSubmitDialog = true;
            }
        },

        jumpListPage() {
            this.$router.push('/mng/role');
        },
        save(e) {
            if (e) {
                // e.preventDefault();
            }
            let reqParam = {};
            if (this.type === 1) {
                reqParam = {
                    type: this.type,
                    roleId: this.roleId,
                    roleName: this.roleName,
                    privileges: this.privileges,
                    terminal_privileges: this.terminalPrivileges,
                    packages: this.packages,
                    dataRole: JSON.stringify(this.dataPriv),
                };
            } else {
                reqParam = {
                    id: this.roleId,
                    name: this.roleName,
                    privilege: this.privileges,
                    terminalPrivilege: this.terminalPrivileges,
                    combos: this.packages,
                    dataPrivilege: JSON.stringify(this.dataPriv),
                };
            }

            if (!this.validate()) {
                return false;
            }

            // 新建或编辑一个员工数量为0的角色时，不需要判断是否涉及端踢下线权限变更
            if (this.isCreate || this.memNum === 0) {
                this.roleEditReq(reqParam);
            } else {
                terminalPriCheck(
                    'roleCreate',
                    {
                        type: this.type,
                        roleId: this.roleId,
                        roleName: this.roleName,
                        privileges: this.privileges,
                        terminal_privileges: this.terminalPrivileges,
                        packages: this.packages,
                        dataRole: JSON.stringify(this.dataPriv),
                    },
                    () => {
                        this.roleEditReq(reqParam);
                    },
                );
            }

            return false;
        },
        customFn(res) {
            const { code: intCode, message, msg } = res;
            this.saveLoading = false;
           if (intCode === 40033) {
                window.removeEventListener('beforeunload', this.unloadTipFunc, false);
                this.$message.error(message || '权限范围发生变更，请重新登录');
                sessionStorage.setItem('over_power_reload_flag', 1);
                this.jumpListPage();
            } else if (intCode === 50005 || intCode === 41035) {
                this.showUnderQuotaDialog = true;
            } else {
                this.$message.error(msg || message || '保存失败');
            }
        },
        roleEditReq(reqParam) {
            this.saveLoading = true;
            this.$ajax[this.confirmCgiType](this.confirmCgiUrl, reqParam, { customFn: this.customFn }).then(
                (res) => {
                    const { code, roleId, msg, message, data } = res || {};
                    const { subCode: dataCode, boId: subBoId, msg: subMsg } = data || {};
                    const intCode = parseInt(code, 10);
                    this.errBoId = -1;

                    if (dataCode === 40034) {
                        this.errBoId = subBoId;
                        this.$message.error(subMsg || '保存失败');
                    } else if (intCode === 0 || roleId) {
                        this.refreshList = true;

                        this.$message.success('保存成功', () => {
                            this.jumpListPage();
                        });
                    }  else {
                        this.$message.error(msg || message || '保存失败');
                    }
                    this.saveLoading = false;
                },
                (error) => {
                    this.$message.error((error && error.message) || '请求出错');
                    this.saveLoading = false;
                },
            );
        },

        validate() {
            let errMsg = '';
            const nameErrMsg = this.$refs.roleNameInput.getErrMsg();

            if (nameErrMsg) {
                return false;
            }

            if (!this.roleId) {
                errMsg = '缺少角色id';
            } else if (this.privileges.length <= 0 && this.terminalPrivileges.length <= 0) {
                errMsg = '请选择权限';
            } else if (this.confirmPackages.length > 0) {
                this.choosePackage();
                return false;
            }

            if (errMsg) {
                this.$message.error(errMsg);
                return false;
            }

            return true;
        },

        // 当最终权限列表归属多个套餐都可以用时，需要用户选择来选用哪个套餐的配额
        choosePackage() {
            if (this.comboPackageHandle()) {
                this.showChoosePackageDialog = true;
            } else {
                this.save();
            }
        },

        choosePackageConfirm() {
            this.packages.push(this.choosePackageVal);
            this.confirmPackages.splice(0, 1);
            this.save();
        },

        /**
         * 套餐叠加售卖处理
         * 协同+客服, 协同角色去除客服套餐选项，客服角色去除协同选项，剩下一个选项不出现弹框，多个选项出现弹框
         */
        comboPackageHandle() {
            const packList = this.confirmPackages[0];
            let confirmOpts = [];
            let needConfirm = true;
            let hasXtPack = false;
            const xtOpts = [];
            const kfOpts = [];

            packList.forEach((packKey) => {
                if (isXtPackage(packKey)) {
                    xtOpts.push(packKey);
                    hasXtPack = true;
                } else {
                    kfOpts.push(packKey);
                }
            });

            if (hasXtPack) {
                if (this.xtRole) {
                    confirmOpts = xtOpts;
                } else {
                    confirmOpts = kfOpts;
                }

                if (confirmOpts.length === 1) {
                    this.packages.push(confirmOpts[0]);
                    this.confirmPackages.splice(0, 1);
                    needConfirm = false;
                } else if (confirmOpts.length > 1) {
                    this.confirmPackages.splice(0, 1, confirmOpts);
                    needConfirm = true;
                }
            }

            return needConfirm;
        },

        cancelClick() {
            this.$router.push('/mng/role');
        },
        getCombos() {
            ajax.gatewayGet('/v1/role/combos', { roleId: this.roleId }).then((res) => {
                if (res && res.code === 0) {
                    const { current, others } = res.data || {};
                    this.otherCombos = others;
                    this.curCombos = current;
                }
            });
        },
        custom(res) {
            this.setPageLoading();
            this.$message.error(res?.message || '查询失败，请稍后重试');
        },
        getRoleInfo() {
            this.$ajax
                .read('/mng/role/roleList', {
                    roleId: this.roleId,
                }, { customFn: this.custom })
                .then(
                    (res) => {
                        const { code, list, message } = res || {};
                        if (parseInt(code, 10) === 0) {
                            const roleData = (list && list[0]) || {};
                            this.roleName = roleData.roleName;
                            this.memNum = roleData.memNum;
                            this.hasQQPrivilege = roleData.hasQQPrivilege;
                            this.xtRole = this.isXTRole(roleData.packages);
                            this.hasRoleInfoInit = true;
                            this.setPageLoading();
                        } else {
                            this.$message.error(message || '请求角色信息失败');
                        }
                    },
                    (error) => {
                        this.$message.error((error && error.message) || '请求出错');
                    },
                );
        },

        getTplData(id) {
            this.$ajax.read('/mng/role/RoleTpl').then(
                (res) => {
                    const { tpls } = res || {};
                    if (tpls && tpls.length) {
                        tpls.forEach((item) => {
                            const { tplId, packages } = item || {};

                            if (id === `${tplId}`) {
                                this.xtRole = this.isXTRole(packages);
                            }
                        });
                    }
                },
                (error) => {
                    this.$message.error((error && error.message) || '请求出错');
                },
            );
        },

        setPageLoading() {
            if (this.hasRoleInfoInit && this.hasPrivInit) {
                this.pageLoading = false;
            }
        },

        // 是否是协同角色
        isXTRole(packages) {
            let bool = false;
            for (const k in packages) {
                if (isXtPackage(k)) {
                    bool = true;
                }
            }
            return bool;
        },

        beforeUnloadTip() {
            window.addEventListener(
                'beforeunload',
                // eslint-disable-next-line consistent-return
                (e) => {
                    const confirmationMessage = '离开此页面后您正在编辑的内容将丢失，是否继续？';
                    if (this.isChange) {
                        (e || window.event).returnValue = confirmationMessage;
                        return confirmationMessage;
                    }
                    // return e;
                },
                false,
            );
        },

        // 获取套餐信息
        getPackagesInfo() {
            const reqData = {
                use_cache: true,
                detail: true,
            };

            Gateway.post('/v1/combo/getFullCombos', reqData).then((data) => {
                const combos = (data && data.combos) || {};

                Object.keys(combos).forEach((k) => {
                    const pck = combos[k] || {};
                    this.$set(this.packageInfo, k, pck.name);
                    // this.packageInfo[k] = pck.name;
                });
            });
            // console.log("packages", this.packageInfo);

            if (window.QD_ADMIN_COMMON && window.QD_ADMIN_COMMON.data) {
                const { available } = window.QD_ADMIN_COMMON.data.set || {};

                if (available && available.length) {
                    available.forEach((item) => {
                        const { id, name } = item || {};
                        this.packageInfo[id] = name;
                    });
                }
            }
        },
    },
};
</script>
<style lang="less">
.base-dialog {
    .v-dialog__container {
        max-width: 440px !important;
    }
}

.base-dialog-underQuota {
    .v-dialog__container {
        max-width: 440px !important;
        height: 266px;

        .v-dialog__content {
            padding: 40px 30px 45px;
        }
    }
}
.package-show {
    margin: 39px 0px;
    font-size: 14px;

    &__title {
        height: 20px;
        font-weight: 400;
        line-height: 20px;
        margin-bottom: 12px;
        color: #a8abb3;
    }

    &__list {
        margin-bottom: 6px;
    }

    &__item {
        display: inline-block;
        line-height: 20px;
        height: 20px;
        margin-right: 24px;
    }

    &__desc {
        color: rgba(1, 11, 50, 0.41);
    }

    &__footer {
        font-size: 12px;
        color: rgba(1, 11, 50, 0.41);
        .v-icon {
            width: 14px;
            height: 14px;
            margin-right: 2px;
            color: rgba(1, 11, 50, 0.41);
            position: relative;
            top: 3px;
        }
    }


    &__footerItem {
        display: inline-block;
        height: 16px;
        line-height: 16px;
    }

}
</style>
